module.exports = __webpack_public_path__ + "static/media/move-right.0ce96ea0.svg";